module.exports = __webpack_public_path__ + "img/call_missed.3c37ba13.svg";